module.exports = __webpack_public_path__ + "static/media/wx-qrcode.a1a1a0a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx-qrcode.png
// module id = 2011
// module chunks = 2